import {
  Box,
  Button,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import Logo from "assets/images/logo-orange.png";
import Container from "components/Container";
import { useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import OTPInput from "components/Login/OTPInput";
import { validatePhoneNumber } from "utils/helper";
import { useMutation } from "@tanstack/react-query";
import { LOGIN, VERIFY_OTP } from "services";
import { useDispatch } from "react-redux";
import { showToast } from "store/slices/toastSlice";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [phone, setPhone] = useState("");
  const [showOtp, setShowOtp] = useState(false);
  const otpLength = 6;
  const [otp, setOtp] = useState(new Array(otpLength).fill(""));
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const handlePhoneChange = (e) => {
    if (!validatePhoneNumber(e.target.value, "change")) { return; }
    setPhone(e.target.value);
  };

  const loginMutation = useMutation({
    mutationFn: LOGIN,
    onSuccess: ({ status, statusmessage }) => {
      if (status) {
        setShowOtp(true);
      } else {
        dispatch(showToast({ message: statusmessage, severity: "error" }));
      }
    },
    onError: () => {
      dispatch(showToast({ message: "Login Failed", severity: "error" }));
    }
  });

  const verifyOtpMutation = useMutation({
    mutationFn: VERIFY_OTP,
    onSuccess: ({ status, statusmessage, token }) => {
      if (status) {
        localStorage.setItem("token", token);
        localStorage.setItem("phone", phone);
        navigate("/dashboard");
      } else {
        dispatch(showToast({ message: statusmessage, severity: "error" }));
      }
    },
    onError: () => {
      dispatch(showToast({ message: "Verify OTP Failed", severity: "error" }));
    }
  });

  const handleVerifyOtp = () => {
    verifyOtpMutation.mutate({ phone, otp: otp.join("") });
  };

  const handleSendOtp = () => {
    loginMutation.mutate({ phone });
  };

  return (
    <Box sx={{
      width: "100%", height: "100vh", display: "flex", justifyContent: "center", alignItems: "center"
    }}>

      <Container sx={{ width: "100%", maxWidth: "500px", margin: 2 }}>
        <Stack spacing={2}>
          {showOtp ? (
            <Stack spacing={2}>
              <Stack direction="row" alignItems="center">
                <ArrowBackIcon sx={{ color: "text.primary" }} />
                <Typography sx={{ cursor: "pointer" }} onClick={() => setShowOtp(false)}>
                  Back
                </Typography>
              </Stack>

              <img src={Logo} style={{ width: "100px" }} alt="Ezid logo" />
              <Typography variant="h3" color="primary.main" fontWeight={600}>Enter Verification Code</Typography>
              <Typography>
                Please enter the OTP we just sent to
                {" "}
                <Typography component="span" color="primary.main">
                  {phone}
                </Typography>
                .
              </Typography>
              <OTPInput otp={otp} setOtp={setOtp} handleSendOtp={handleSendOtp} />
              <Button variant="contained" color="primary" size="large" onClick={handleVerifyOtp}>Log In</Button>

            </Stack>
          ) : (
            <Stack spacing={2}>
              <img src={Logo} style={{ width: "100px" }} alt="Ezid logo" />
              <Typography variant="h2" color="primary.main" fontWeight={600} sx={isMobile ? { fontSize: 36, letterSpacing: -1 } : {}}>Access EZiD&apos;s 2025 Grand Draw</Typography>
              <Typography>View your grand draw progress, track your friend referrals and see your chances of winning a Tesla Model Y in 2025 grow.</Typography>
              <Typography variant="h6" color="primary.main" fontWeight={600}>
                Log In
              </Typography>
              <TextField label="Mobile Number" variant="outlined" placeholder="Mobile Number" name="phone" value={phone} onChange={(e) => handlePhoneChange(e)} />
              <Button variant="contained" color="primary" size="large" onClick={handleSendOtp} disabled={!validatePhoneNumber(phone)}>Continue With Mobile Number</Button>
            </Stack>
          )}
          <Typography variant="xs">By logging in/signing up, you acknowledge that you have read and understood, and agree to EZiD&apos;s Terms of Service and Privacy Policy.</Typography>
        </Stack>

      </Container>

    </Box>
  );
}
